import { startRegistration, startAuthentication } from '@simplewebauthn/browser';
import axios from 'axios';
import API from './api';

/**
 * Registra la huella/cara en el servidor
 */
export const registerBiometry = async () => {
    try {
        const token = localStorage.getItem("rider_token");
        if (!token) throw new Error("No hay sesión activa");

        // 1. Obtener opciones del servidor
        const optionsRes = await axios.post(`${API}/rider/webauthn/register-options`, {}, {
            headers: { Authorization: `Bearer ${token}` }
        });

        // 2. Iniciar el sensor del dispositivo
        const attestationResponse = await startRegistration({
            optionsJSON: optionsRes.data
        });

        // 3. Enviar la respuesta al servidor para verificar y guardar llave pública
        const verifyRes = await axios.post(`${API}/rider/webauthn/register-verify`, attestationResponse, {
            headers: { Authorization: `Bearer ${token}` }
        });

        return verifyRes.data;
    } catch (error) {
        console.error("Biometry registration error:", error);
        throw error;
    }
};

/**
 * Inicia sesión usando la huella registrada
 */
export const loginWithBiometry = async (phone) => {
    try {
        // 1. Obtener retos del servidor para este teléfono
        const optionsRes = await axios.post(`${API}/rider/webauthn/login-options`, { phone });

        // 2. Iniciar autenticación en el dispositivo
        const assertionResponse = await startAuthentication({
            optionsJSON: optionsRes.data
        });

        // 3. Verificar en el servidor y obtener el JWT
        const verifyRes = await axios.post(`${API}/rider/webauthn/login-verify`, {
            phone,
            response: assertionResponse
        });

        return verifyRes.data; // Retorna { access_token, driver }
    } catch (error) {
        console.error("Biometry login error:", error);
        throw error;
    }
};

/**
 * Verifica si el dispositivo soporta biometría WebAuthn
 */
export const isBiometrySupported = () => {
    return window.PublicKeyCredential &&
        typeof window.PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable === 'function';
};

/**
 * Verifica si el dispositivo tiene un sensor de biometría local (huella/cara) disponible
 */
export const isBiometryAvailable = async () => {
    if (!isBiometrySupported()) return false;
    return await window.PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable();
};
